import { Box } from "@mui/material"
import { makeStyles } from "makeStyles"
import Icon from "@mdi/react"
import { mdiTruck, mdiTools } from "@mdi/js"

import Link from "../../../components/i18n/Link"
import useTranslationCustom from "hooks/useTranslation"

const useStyles = makeStyles()((theme) => ({
	icon: {
		color: theme.palette.primary.main,
	},
}))

const AdditionalShippingInformation = () => {
	const { classes } = useStyles()
	const { t } = useTranslationCustom("product")

	return (
		<>
			<Box my={2} ml={1} style={{ width: "100%" }}>
				<strong>{t("additionalInformation")}</strong>
			</Box>
			<Box mb={2} ml={1}>
				<Link href="/help/delivery" target="_blank">
					<div style={{ display: "flex", textDecoration: "underline" }}>
						<Box mr={1}>
							<Icon path={mdiTruck} size={0.8} className={classes.icon} />
						</Box>
						{t("delivery")}
					</div>
				</Link>
				<Link href="/help/assembly" target="_blank">
					<Box mt={1} style={{ display: "flex", textDecoration: "underline" }}>
						<Box mr={1}>
							<Icon path={mdiTools} size={0.8} className={classes.icon} />
						</Box>
						{t("assembly")}
					</Box>
				</Link>
			</Box>
		</>
	)
}

export default AdditionalShippingInformation
